import { useEffect, useState } from 'react';
import Title from '../../../componente/cadastro/titulo/index.jsx';
import Description from '../../../componente/cadastro/descricao/index.jsx';
import SearchField from '../../../componente/cadastro/busca/index.jsx';
import AddButton from '../../../componente/cadastro/botaoadd/index.jsx';
import Table from '../../../componente/cadastro/tabela/index.jsx';
import Pagination from '../../../componente/cadastro/paginacao/index.jsx';
import Sidebar from "../../../componente/sidebar/index.jsx";
import "./style.css";
import api from "../../../services/api.js";
import { useAppContext } from "../../context/AppContext.jsx";
import { toast } from 'react-hot-toast';
import Modal from "react-modal";
import PopUp from "../../../componente/popup/index.jsx";
import { usePermissoes } from "../../../componente/permissoes";

Modal.setAppElement("#root");

const CadMoeda = () => {
    const { podeInserir, podeEditar, podeExcluir } = usePermissoes();

    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(50);
    const [data, setData] = useState([]);
    const [pagination, setPagination] = useState({
        total: 0,
        totalPages: 0
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [showform, setshowform] = useState(false);
    const { accessKey, codassinante, codempresa, codusuario } = useAppContext(); // Acessa os dados do contexto          
    const [novo, setnovo] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const columns = [
        { key: 'codmoeda', title: 'Código' },
        { key: 'descricao', title: 'Moeda' },
        { key: 'tipo', title: 'Tipo' },
    ];

    //campos
    const [codmoeda, setCodMoeda] = useState(0);
    const [moeda, setMoeda] = useState("");
    const [tipo, setTipo] = useState("");

    const handleOpen = (cad) => {
        setCodMoeda(cad.codmoeda);
        setIsOpen(true);
    };

    const handleConfirma = () => {
        setIsOpen(false);
        handleDelete();
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    const fetchData = async (searchTerm, page, limit) => {
        try {
            setLoading(true);
            setError(null);
            const response = await api.get("v1/cad/moeda", {
                params: {
                    busca: searchTerm,
                    page,
                    per_page: limit,
                    codassinante,
                    codempresa
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            setData(response.data.data);
            setPagination({
                total: response.data.pagination.Total,
                totalPages: response.data.pagination.TotalPages
            });
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            setError('Erro ao carregar os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            fetchData(search, currentPage, perPage);
        }, 1000); // Aguarda 1 segundo após o usuário parar de digitar

        // Cleanup function para limpar o timeout anterior
        return () => clearTimeout(timeoutId);
    }, [search, currentPage, perPage, codempresa]);

    const handlePerPageChange = (newPerPage) => {
        setPerPage(newPerPage);
        setCurrentPage(1); // Volta para primeira página ao mudar quantidade
    };

    const handleEdit = async (user) => {
        try {
            setLoading(true);
            setError(null);
            const response = await api.get("v1/cad/moedaum", {
                params: {
                    codmoeda: user.codmoeda
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            setshowform(true);
            setnovo(false);

            setCodMoeda(user.codmoeda);
            setMoeda(response.data.descricao);
            setTipo(response.data.tipo);
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            setError('Erro ao carregar os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async () => {
        try {
            setLoading(true);
            setError(null);
            await api.delete("v1/cad/moeda", {
                params: {
                    codmoeda,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            fetchData(search, currentPage, perPage);
            toast.success('Excluído com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    };

    const handleAdd = () => {
        setshowform(true);
        setnovo(true);

        setCodMoeda(0);
        setMoeda('');
        setTipo('DI');
    };

    function Salvar() {
        novo ? Cadastrar() : Editar();
        setshowform(false);
    }

    async function Editar() {
        try {
            setLoading(true);
            setError(null);
            await api.put("v1/cad/moeda", {
                descricao: moeda,
                tipo,
                codmoeda
            },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },

                });
            fetchData(search, currentPage, perPage);
            toast.success('Edição feita com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    }

    async function Cadastrar() {
        try {
            setLoading(true);
            setError(null);

            if (codempresa === 0) {
                alert('Selecione a filial antes!');
                return; // <-- impede que continue para o POST
            }

            await api.post("v1/cad/moeda", {
                descricao: moeda,
                tipo,
                codempresa,
                excluido: "N",
                codassinante,
                codusuario,
            },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },

                });
            fetchData(search, currentPage, perPage);
            toast.success('Registro Salvo com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <div className="app-container">
                <Sidebar />
                <main className="content-container">
                    <PopUp isOpen={isOpen} onClose={handleClose}>
                        <h2>Verificação</h2>
                        <p>Tem certeza que deseja excluir esse registro?</p>

                        <div className="row">
                            <div className="col-12 mt-3 d-flex justify-content-end">
                                <button
                                    className="btn btn-primary me-2"
                                    onClick={handleConfirma}
                                >
                                    Sim
                                </button>
                                <button className="btn btn-danger" onClick={handleClose}>
                                    Não
                                </button>
                            </div>
                        </div>
                    </PopUp>

                    <Modal
                        isOpen={showform}
                        onRequestClose={() => setshowform(false)}
                        overlayClassName="modal-overlay"
                        className="modal-content modal-xl"
                    >
                        <div className="container-fluid h-100">
                            <div className="modal-header">
                                {novo ? <h2>Novo Cadastro</h2> : <h2>Editando Cadastro</h2>}
                                <button type="button" className="btn-close" onClick={() => setshowform(false)}></button>
                            </div>

                            <div className="modal-body">
                                <form>
                                    <div className='row'>
                                        <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    id="moeda"
                                                    value={moeda}
                                                    onChange={(e) => setMoeda(e.target.value)}
                                                />
                                                <label htmlFor="moeda">Moeda</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-group">
                                                <label className="form-label">Tipo de Moeda</label>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        id="dinheiro"
                                                        name="tipomoeda"
                                                        value="DI"
                                                        checked={tipo === "DI"}
                                                        onChange={(e) => setTipo(e.target.value)}
                                                    />
                                                    <label className="form-check-label" htmlFor="dinheiro">
                                                        Dinheiro
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        id="pix"
                                                        name="tipomoeda"
                                                        value="PX"
                                                        checked={tipo === "PX"}
                                                        onChange={(e) => setTipo(e.target.value)}
                                                    />
                                                    <label className="form-check-label" htmlFor="pix">
                                                        Pix
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        id="cartaodebito"
                                                        name="tipomoeda"
                                                        value="CD"
                                                        checked={tipo === "CD"}
                                                        onChange={(e) => setTipo(e.target.value)}
                                                    />
                                                    <label className="form-check-label" htmlFor="cartaodebito">
                                                        Cartão Débito
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        id="cartaocredito"
                                                        name="tipomoeda"
                                                        value="CC"
                                                        checked={tipo === "CC"}
                                                        onChange={(e) => setTipo(e.target.value)}
                                                    />
                                                    <label className="form-check-label" htmlFor="cartaocredito">
                                                        Cartão Crédito
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        id="boleto"
                                                        name="tipomoeda"
                                                        value="BO"
                                                        checked={tipo === "BO"}
                                                        onChange={(e) => setTipo(e.target.value)}
                                                    />
                                                    <label className="form-check-label" htmlFor="boleto">
                                                        Boleto
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        id="promissoria"
                                                        name="tipomoeda"
                                                        value="PR"
                                                        checked={tipo === "PR"}
                                                        onChange={(e) => setTipo(e.target.value)}
                                                    />
                                                    <label className="form-check-label" htmlFor="promissoria">
                                                        Promissoria
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" onClick={() => setshowform(false)}>
                                    Cancelar
                                </button>
                                <button type="button" className="btn btn-success" onClick={Salvar}>
                                    Salvar
                                </button>

                            </div>
                        </div>
                    </Modal>

                    <div className="container-fluid py-4 d-flex flex-column" style={{ minHeight: '100vh' }}>
                        <Title text="Cadastro de Moeda" icon="user" />
                        <Description text="Cadastro das moedas, que são as formas de pagamento para receber e pagar." />

                        <div className="row mb-3">
                            <div className="col-xl-10 col-lg-8 col-md-8 col-sm-12">
                                <SearchField
                                    value={search}
                                    onChange={setSearch}
                                    placeholder="Buscar caixas por: Código ou Moeda"
                                />
                            </div>
                            <div className="col-xl-2 col-lg-4 col-md-4 col-sm-12 text-center">
                                <AddButton onClick={handleAdd} text="Nova Moeda" disabled={!podeInserir("/cad/moeda")}/>
                            </div>
                        </div>

                        {error && (
                            <div className="alert alert-danger" role="alert">
                                {error}
                            </div>
                        )}

                        <div className="flex-grow-1 d-flex flex-column">
                            {loading ? (
                                <div className="text-center py-4">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Carregando...</span>
                                    </div>
                                </div>
                            ) : (
                                <div className="table-wrapper flex-grow-1 d-flex flex-column">
                                    <Table
                                        columns={columns}
                                        data={data}
                                        onEdit={handleEdit}
                                        isEditDisabled={() => !podeEditar("/cad/moeda")}
                                        onDelete={handleOpen}
                                        isDeleteDisabled={() => !podeExcluir("/cad/moeda")}
                                    />
                                </div>
                            )}
                        </div>

                        <Pagination
                            currentPage={currentPage}
                            totalPages={pagination.totalPages}
                            onPageChange={setCurrentPage}
                            perPage={perPage}
                            onPerPageChange={handlePerPageChange}
                            total={pagination.total}
                        />
                    </div>
                </main>
            </div>
        </>
    );
};

export default CadMoeda;